// src/components/Dashboard.js

import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Toast, ToastContainer } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectTokens, selectAppRoles } from '../redux/userSlice';
import MessageComponent from './MessageComponent';
import AppPortal from './AppPortal';
import './Dashboard.css'; // Import the updated file
import SendMessageComponent from './SendMessageComponent';
import EmailComponent from './EmailComponent';
import DocumentManager from './DocumentManager';
import UserManagementComponent from './UserManagementComponent';
import UploadDocumentComponent from './UploadDocumentComponent';
import SaleRegistrationsComponent from './SaleRegistrationsComponent';
import UserNotes from './UserNotes';

import { 
  FaBell, 
  FaPaperPlane, 
  FaUsers, 
  FaFileUpload, 
  FaFolderOpen, 
  FaClipboardList, 
  FaChartLine 
} from 'react-icons/fa';

const Dashboard = () => {
  const [showToast, setShowToast] = useState(false)
  const [toastHeader, setToastHeader] = useState(false)
  const [toastBody, setToastBody] = useState(false)
  const tokens = useSelector(selectTokens);
  const appRoles = useSelector(selectAppRoles);
  const navigate = useNavigate();

  // When tokens are cleared (logged out), navigate to the home page.
  useEffect(() => {
    if (!tokens.accessToken) {
      navigate('/');
    }
  }, [tokens.accessToken, navigate]);

  // Updated to handle both uppercase and lowercase role keys.
  const hasPortalAdminAccess = 
    appRoles?.PORTAL === 'Portal Admin' || 
    appRoles?.portal === 'Portal Admin';


  return (
    <div className="my-dashboard-container">
       {/* On Success Toast Notification */}
                    <ToastContainer
                      position="top-end"
                      className="p-3 unique-auction-toast-container"
                    >
                      <Toast
                        onClose={() => setShowToast(false)}
                        show={showToast}
                        delay={8000}
                        autohide
                        bg="warning"
                      >
                        <Toast.Header>
                          <strong className="me-auto">{toastHeader}</strong>
                        </Toast.Header>
                        <Toast.Body>
                          <div style={{ marginBottom: "10px" }}>
                            {toastBody}
                          </div>
                        </Toast.Body>
                      </Toast>
                    </ToastContainer>
      <div className="my-dashboard-item">
        <MessageComponent />
      </div>
      <div className="my-dashboard-item">
        <AppPortal tokens={tokens} />
      </div>

      {hasPortalAdminAccess && (
        <div className="my-dashboard-control-center">
          <Tabs defaultActiveKey="sendMessage" id="dashboard-tabs" justify>
            <Tab eventKey="sendMessage" title={<><FaBell /> Send Notification</>}>
              <SendMessageComponent />
            </Tab>
            <Tab eventKey="sendEmail" title={<><FaPaperPlane /> Send Email</>}>
              <EmailComponent />
            </Tab>
            <Tab eventKey="manageDocuments" title={<><FaFolderOpen /> Manage Documents</>}>
              <DocumentManager />
            </Tab>
            <Tab eventKey="manageUsers" title={<><FaUsers /> Manage Users</>}>
              <UserManagementComponent setToastHeader={setToastHeader} setToastBody={setToastBody} setShowToast={setShowToast}/>
            </Tab>
            <Tab eventKey="uploadDocument" title={<><FaFileUpload /> Upload Document</>}>
              <UploadDocumentComponent />
            </Tab>
            <Tab eventKey="manageRegistrations" title={<><FaClipboardList /> Manage Registrations</>}>
              <SaleRegistrationsComponent />
            </Tab>
            <Tab eventKey="viewInsights" title={<><FaChartLine /> View Insights</>}>
              <UserNotes />
            </Tab>
          </Tabs>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
